import React, { useState } from 'react';

import Skeleton from 'react-loading-skeleton';

import { useTable, usePagination } from 'react-table';

import TableContainer from '@material-ui/core/TableContainer';
import MaUTable from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import { Pagination } from './pagination';

import './styles.css';

export const Table = ({ columns, data, isLoading }) => {
  // Use the state and functions returned from useTable to build your UI
  const { 
    getTableProps, 
    headerGroups, 
    rows,
    prepareRow, 
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    gotoPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 15 }, // Pass our hoisted table state
    }, 
    usePagination
  );

  const handleChangeRows = (event) => {
    setPageSize(parseInt(event.target.value, 15));
    gotoPage(0);
  };

  const handlePageChange = (event, newPage) => {
    gotoPage(newPage);
  };

  // Render the UI for your table
  return (
    <TableContainer component={Paper}>
      <MaUTable {...getTableProps()} >
        <TableHead>
          {headerGroups.map(headerGroup => (
            <TableRow {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <TableCell {...column.getHeaderProps()}>
                  {column.render('Header')}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableHead>
        <TableBody>
          <TableRow 
            className={`${isLoading ? 'fadeIn' : 'fadeOut'}`} 
            key="skeletonRow" 
            width={100}>

            <TableCell colSpan="10" align="center">
              <Skeleton count={15} height={40} />
            </TableCell>
          </TableRow>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <TableRow className="fadeIn" {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return (
                    <TableCell {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </TableCell>
                  )
                })}
              </TableRow>
            )
          })}
        </TableBody>
      </MaUTable>
      <Grid
        container
        direction="column"
        alignContent="flex-end"
        alignItems="flex-end"
        style={{ marginTop: '1em', marginBottom: '1em' }}
      >
        <Grid item>
          <TablePagination
            rowsPerPageOptions={[15, 30, 50, 100]}
            component="div"
            page={pageIndex}
            count={rows.length}
            rowsPerPage={pageSize}
            onRowsPerPageChange={handleChangeRows}
            onPageChange={handlePageChange}
            ActionsComponent={Pagination}
          />
        </Grid>
      </Grid>
    </TableContainer>
  );
}